module.exports = __webpack_public_path__ + "fonts/14f037f98c26498dca8f8b8f6d80ba15-Roboto-BlackItalic.woff2";